import { createFileRoute } from '@tanstack/react-router'
import { ContractStakeholderTypesPage } from '../../../components/ContractStakeholderTypesPage'

export const Route = createFileRoute('/$org/contract-stakeholder-types/')({
  component: ContractStakeholderTypes,
})

function ContractStakeholderTypes() {
  return <ContractStakeholderTypesPage />
}